import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-baja-atajo-modal',
  templateUrl: './baja-atajo-modal.component.html',
  styleUrls: ['./baja-atajo-modal.component.css']
})
export class BajaAtajoModalComponent implements OnInit {

  bajaForm: FormGroup;
  show  = false;
  constructor(public diaalogRef: MatDialogRef<BajaAtajoModalComponent>) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void{
    this.bajaForm = new FormGroup({
      tipo : new FormControl('', Validators.required),

      paisDestino: new FormControl(''),
      numPedido: new FormControl('')

    });
  }

  changeEstado(event): void {
    console.log(event.value);
    switch (event.value) {
      case 'BAJA EXPORTACION':
        this.show = true;
        this.bajaForm.get('paisDestino').setValidators(Validators.required);
        break;
      default:
        this.show = false;
        this.bajaForm.get('paisDestino').clearValidators();
        this.bajaForm.get('paisDestino').reset();
        break;
    }
    this.bajaForm.get('paisDestino').updateValueAndValidity();
  }
}
